import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useDocumentUpload } from 'Core/hooks';
import CustomPropTypes from 'CustomPropTypes';

const styles = {
    uploadContainer: {
        background: 'white',
        borderRadius: '4px',
        // padding: '15px',
    },
    uploadArea: {
        marginBottom: '15px',
    },
    uploadLabel: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        width: '100%',
        height: '120px',
        border: '2px dashed #ccc',
        borderRadius: '4px',
        cursor: 'pointer',
        backgroundColor: '#f9f9f9',
        transition: 'background-color 0.2s',
    },
    uploadContent: {
        textAlign: 'center',
    },
    uploadIcon: {
        fontSize: '16px',
        color: '#666',
        marginBottom: '8px',
    },
    uploadText: {
        fontSize: '14px',
        color: '#666',
        marginBottom: '4px',
    },
    uploadBold: {
        fontWeight: 600,
    },
    uploadSubtext: {
        fontSize: '12px',
        color: '#888',
    },
    hiddenInput: {
        display: 'none',
    },
    previewGrid: {
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fill, minmax(150px, 1fr))',
        gap: '15px',
        marginTop: '15px',
    },
    previewItem: {
        position: 'relative',
        borderRadius: '4px',
        overflow: 'hidden',
        boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)',
    },
    previewImageContainer: {
        position: 'relative',
        paddingTop: '75%' /* 4:3 Aspect Ratio */,
    },
    previewImage: {
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        objectFit: 'cover',
    },
    removeButton: {
        position: 'absolute',
        top: '8px',
        right: '8px',
        width: '20px',
        height: '20px',
        borderRadius: '50%',
        backgroundColor: '#ff4444',
        color: 'white',
        border: 'none',
        cursor: 'pointer',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontSize: '14px',
        opacity: 0,
        transition: 'opacity 0.2s',
    },
    fileName: {
        position: 'absolute',
        bottom: 0,
        left: 0,
        right: 0,
        backgroundColor: 'rgba(255, 255, 255, 0.9)',
        padding: '6px 8px',
        fontSize: '12px',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
    },
};

const initData = {
    id: 0,
    partId: 0,
    fileName: '',
    filePath: '',
    relativePath: '',

};

const UploadImage = ({ data, onChanges, name, fileUrl }) => {

    const [imageFiles, setImageFiles] = useState(data);

    const { uploadDocuments, loading } = useDocumentUpload();
    const [isHovering, setIsHovering] = useState(false);

    useEffect(() => {
        const filenameList = fileUrl ? fileUrl.split('.') : [];
        setImageFiles(prevState => {
            console.log(prevState)
            return [
            (prevState && prevState[0] ? {
                ...prevState[0],
                fileName: prevState[0].fileName ? prevState[0].fileName : (filenameList.length ? filenameList[filenameList.length - 2] : ''),
                relativePath: fileUrl
            } : {
                fileName: filenameList.length ? filenameList[filenameList.length - 2] : '',
                relativePath: fileUrl
            }),

        ]});

    }, [fileUrl]);

    const handleFileUpload = async event => {
        const files = Array.from(event.target.files);

        const formData = new FormData();
        formData.append('file', files[0]);
        formData.append('UploadCategory', 'Part-UploadImage');

        const result = await uploadDocuments(formData);
        if (result) {
            const newFile = {
                id: Math.floor(Math.random() * 101),
                fileName: result.fileName,
                filePath: result.filePath,
                relativePath: result.relativePath,
            };
            const newFiles = [newFile];

            setImageFiles(newFiles);
            if (onChanges) onChanges({
                filePath: result.relativePath,
                extension: result.fileName.split('.').pop()
            });
        }
    };

    const removeFile = fileId => {
        const newFiles = imageFiles.filter(imageFile => imageFile.id !== fileId);
        setImageFiles(newFiles);
        if (onChanges) onChanges({
            filePath: '',
            extension: ''
        });
    };

    // useEffect(() => {
    //     if (onChanges) onChanges({
    //         filePath: imageFiles[0] ? imageFiles[0].relativePath : '',
    //         extension: imageFiles[0] ? imageFiles[0].fileName.split('.').pop() : ''
    // });
    // }, [imageFiles, onChanges]);
    console.log(imageFiles)
    return (
        <div style={styles.uploadContainer}>
            <div style={styles.uploadArea}>
                <label
                    htmlFor="file-upload"
                    style={{
                        ...styles.uploadLabel,
                        backgroundColor: isHovering ? '#f0f0f0' : '#f9f9f9',
                    }}
                    onMouseEnter={() => setIsHovering(true)}
                    onMouseLeave={() => setIsHovering(false)}
                >
                    <div style={styles.uploadContent}>
                        <div style={styles.uploadIcon}>↑</div>
                        <p style={styles.uploadText}>
                            <span style={styles.uploadBold}>Click to upload</span> or drag and drop
                        </p>
                        <p style={styles.uploadSubtext}>PNG, JPG, GIF up to 10MB</p>
                    </div>
                    <input
                        id="file-upload"
                        type="file"
                        name={name}
                        style={styles.hiddenInput}
                        accept="image/*"
                        onChange={handleFileUpload}
                    />
                </label>
            </div>

            {imageFiles.length > 0 && imageFiles[0].relativePath && (
                <div style={styles.previewGrid}>
                    {imageFiles.map(file => (
                        <div
                            key={file.id}
                            style={styles.previewItem}
                            onMouseEnter={e => {
                                const removeBtn = e.currentTarget.querySelector('.remove-btn');
                                if (removeBtn) removeBtn.style.opacity = '1';
                            }}
                            onMouseLeave={e => {
                                const removeBtn = e.currentTarget.querySelector('.remove-btn');
                                if (removeBtn) removeBtn.style.opacity = '0';
                            }}
                        >
                            <div style={styles.previewImageContainer}>
                                <img src={file.relativePath} alt={file.fileName} style={styles.previewImage} />
                            </div>
                            <button
                                className="remove-btn"
                                onClick={() => removeFile(file.id)}
                                style={styles.removeButton}
                                title="Remove file"
                            >
                                ×
                            </button>
                            <div style={styles.fileName}>{file.fileName}</div>
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
};

UploadImage.defaultProps = {
    onChanges: () => { },
    data: [],
};

UploadImage.propTypes = {
    onChanges: PropTypes.func,
    data: CustomPropTypes.Files,
    name: PropTypes.string
};

export default UploadImage;
